import { Tag } from "@carbon/react";
import { OverflowMenuVertical } from "@carbon/react/icons";

import { deviceType, fraudAndRiskLevel } from "../../enums";
import { formatAsCurrency } from "../../utils";

import mobileDevice from "../../assets/icons/mobile-device.svg";
import pcMonitor from "../../assets/icons/pc-monitor.svg";

export const fraudsAndRisksDisplayFormatter = (item) => {
  const statusIndicator =
    item.fraudAndRiskLevel === fraudAndRiskLevel.high
      ? { statusText: "high", statusType: "red" }
      : item.fraudAndRiskLevel === fraudAndRiskLevel.low
      ? { statusText: "low", statusType: "green" }
      : { statusText: "medium", statusType: "gray" };

  return {
    ...item,
    amount: (
      <strong>
        {item.currencySymbol} {formatAsCurrency(item.amount)}
      </strong>
    ),
    fraudAndRiskLevel: (
      <Tag className="transaction-status" type={statusIndicator.statusType}>
        <span>{statusIndicator.statusText}</span>
        <div
          style={{ backgroundColor: statusIndicator.statusType }}
          className="status-indicator"
        />
      </Tag>
    ),
    ipAddress: (
      <div>
        <img
          src={
            item.customer.deviceType === deviceType.mobile
              ? mobileDevice
              : pcMonitor
          }
          alt="device type icon"
          className="device-type-icon"
        />{" "}
        {item.customer.ipAddress}
      </div>
    ),
    description: <strong>{item.description}</strong>,
    customer: item.customer.email,
    gateway: (
      <img
        src={`${process.env.PUBLIC_URL}/${item.gatewayLogoUrl}`}
        alt="gateway logo"
      />
    ),
    date: <span className="date--oneline">{item.date}</span>,
    more: <OverflowMenuVertical />,
  };
};
